import objectPath from 'object-path'
import { checkEnableContainer } from 'designer/component/action/Condition'

const addRuleEnableDisableTarget = (targets = [], target = '') => {
  if (!target) return targets
  if (targets.includes(target)) return targets

  targets.push(target)
  return targets
}

const ruleEnableDisableGenericTargetParts = [
  'formData',
  'response',
  'datasource',
  'datasources',
  'urlParam',
  'pathParams',
  'queryParams',
  'condition',
  'provider',
  'user',
  'perspective',
  'setting',
  'settings',
  'config',
  'accountConfig',
  'localStorage',
  'header',
  'body',
  'footer',
  'layout',
  'widget',
  'formGroup',
]

const isRuleEnableDisableGenericTargetPart = (target = '') => {
  return ruleEnableDisableGenericTargetParts.includes(target)
}

const getRuleEnableDisableTargetParts = (target = '') => {
  let targetText = String(target || '')
  let isCompositeTarget = /[|:]/.test(targetText)
  let targetParts = targetText
    .split(/[|:]/)
    .map((key) => key.trim())
    .filter((key) => key)

  if (!isCompositeTarget) return targetParts

  let specificTargetParts = targetParts.filter(
    (targetPart) => !isRuleEnableDisableGenericTargetPart(targetPart),
  )

  return specificTargetParts.length ? specificTargetParts : targetParts
}

const getRuleEnableDisableMatchedKeys = (
  jsonForm = {},
  targetKeys = [],
) => {
  let mapKey = objectPath.get(jsonForm, 'schema.mapKey') || {}
  let mapName = objectPath.get(jsonForm, 'schema.mapName') || {}
  let matchKeys = targetKeys.flatMap((target) =>
    getRuleEnableDisableTargetParts(target),
  )
  let keys = []
  let nameKeys = []

  Object.keys(mapKey).forEach((key) => {
    let fullKey = objectPath.get(mapKey, key) || ''
    let fullName = objectPath.get(mapName, key) || ''
    let shortKey = String(fullKey || '').split('.').pop()
    let shortName = String(fullName || '').split('.').pop()
    let keyMatchList = [key, fullKey, shortKey]
    let nameMatchList = [fullName, shortName]

    if (keyMatchList.some((matchKey) => matchKeys.includes(matchKey))) {
      addRuleEnableDisableTarget(keys, key)
      return
    }
    if (nameMatchList.some((matchKey) => matchKeys.includes(matchKey))) {
      addRuleEnableDisableTarget(nameKeys, key)
    }
  })

  return keys.length ? keys : nameKeys
}

const getRuleEnableDisableTargets = (
  action = {},
  target = '',
  jsonForm = {},
) => {
  let targets = []
  let targetKeys = [
    action.targetKey,
    target,
    action.target,
    action.key,
    action.valueKey,
    action.targetName,
    action.formDataKey,
  ]
  let matchTargetKeys = [...targetKeys, action.targetOptionValue]

  targetKeys.forEach((targetKey) =>
    addRuleEnableDisableTarget(targets, targetKey),
  )
  getRuleEnableDisableMatchedKeys(jsonForm, matchTargetKeys).forEach(
    (targetKey) => addRuleEnableDisableTarget(targets, targetKey),
  )
  if (!targets.length) {
    addRuleEnableDisableTarget(targets, action.targetOptionValue)
  }

  return targets
}

const getRuleEnableDisableSchemaTargets = (
  jsonForm = {},
  targetKeys = [],
) => {
  return targetKeys.filter((targetKey) =>
    objectPath.has(jsonForm, ['schema', 'mapKey', targetKey]),
  )
}

const setRuleEnableDisableUiChanged = (
  designContext = {},
  target,
  status = {},
) => {
  let { isUiChanged = {}, setIsUiChanged } = designContext
  let { isDynamic, dynamicName, dynamicKey, dynamicIndex } = status

  objectPath.set(isUiChanged, target, {
    isRender: true,
    isDynamic,
    dynamicName,
    dynamicKey,
    dynamicIndex,
  })
  if (setIsUiChanged) setIsUiChanged(isUiChanged)
}

const setRuleEnableDisableAction = (
  designContext = {},
  action = {},
  status = {},
  isEnable,
  target,
) => {
  let {
    jsonForm = {},
    elementAction = {},
    setElementAction,
  } = designContext
  let targetKeys = getRuleEnableDisableTargets(action, target, jsonForm)
  if (!targetKeys.length) return undefined
  let schemaTargetKeys = getRuleEnableDisableSchemaTargets(
    jsonForm,
    targetKeys,
  )
  let renderTargetKeys = schemaTargetKeys.length
    ? schemaTargetKeys
    : targetKeys

  targetKeys.forEach((targetKey) => {
    objectPath.set(elementAction, ['isEnable', targetKey], isEnable)
  })
  if (objectPath.has(jsonForm, 'schema.mapKey')) {
    renderTargetKeys.forEach((targetKey) => {
      elementAction = checkEnableContainer(
        targetKey,
        isEnable,
        jsonForm,
        elementAction,
      )
    })
  }
  renderTargetKeys.forEach((targetKey) => {
    setRuleEnableDisableUiChanged(designContext, targetKey, status)
  })
  if (setElementAction) setElementAction(elementAction)
  return isEnable
}

export const onRuleEnable = (
  designContext = {},
  action = {},
  status = {},
  target = '',
) => {
  return setRuleEnableDisableAction(designContext, action, status, true, target)
}

export const onRuleDisable = (
  designContext = {},
  action = {},
  status = {},
  target = '',
) => {
  return setRuleEnableDisableAction(designContext, action, status, false, target)
}
